import React, { useState } from 'react';

function RFIViewer({ rfi, project, onExportPDF, onBack }) {
  const [expandedItem, setExpandedItem] = useState(null);

  if (!rfi || !rfi.rfiItems) return <div>No RFI data</div>;

  const groupedByCategory = rfi.rfiItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  return (
    <div className="rfi-viewer">
      <div className="rfi-header">
        <h2>Request for Information (RFI)</h2>
        <div className="rfi-meta">
          <p><strong>Project:</strong> {project?.name || rfi?.projectName || 'Unknown'}</p>
          <p><strong>Location:</strong> {project?.location || '-'}</p>
          <p><strong>Created:</strong> {new Date(rfi.createdDate).toLocaleDateString()}</p>
          <p><strong>RFI ID:</strong> {rfi.id.substring(0, 8)}</p>
        </div>
      </div>

      <div className="rfi-stats">
        <div className="stat-card">
          <span className="stat-number">{rfi.rfiItems.length}</span>
          <span className="stat-label">Total RFI Items</span>
        </div>
        <div className="stat-card">
          <span className="stat-number">
            {rfi.rfiItems.filter(i => i.priority === 'Critical').length}
          </span>
          <span className="stat-label">Critical Items</span>
        </div>
        <div className="stat-card">
          <span className="stat-number">
            {rfi.rfiItems.filter(i => i.affectsScope).length}
          </span>
          <span className="stat-label">Affects Scope</span>
        </div>
      </div>

      <div className="rfi-items">
        {Object.entries(groupedByCategory).map(([category, items]) => (
          <div key={category} className="rfi-category">
            <h3>{category}</h3>
            <div className="category-items">
              {items.map((item) => (
                <div
                  key={item.number}
                  className={`rfi-item priority-${item.priority.toLowerCase()}`}
                >
                  <div
                    className="rfi-item-header"
                    onClick={() =>
                      setExpandedItem(expandedItem === item.number ? null : item.number)
                    }
                  >
                    <div className="item-number-badge">{item.number}</div>
                    <div className="item-main-info">
                      <p className="item-question">{item.question}</p>
                      <div className="item-tags">
                        <span className={`tag priority-${item.priority.toLowerCase()}`}>
                          {item.priority}
                        </span>
                        <span className="tag trade-tag">{item.tradeConcerned}</span>
                        {item.affectsScope && <span className="tag scope-tag">Affects Scope</span>}
                      </div>
                    </div>
                    <span className="expand-icon">
                      {expandedItem === item.number ? '−' : '+'}
                    </span>
                  </div>

                  {expandedItem === item.number && (
                    <div className="rfi-item-details">
                      <p><strong>Category:</strong> {item.category}</p>
                      <p><strong>Trade Concerned:</strong> {item.tradeConcerned}</p>
                      <p><strong>Affects Scope:</strong> {item.affectsScope ? 'Yes' : 'No'}</p>
                      <p><strong>Notes:</strong> {item.notes}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="rfi-summary">
        <h3>Priority Breakdown</h3>
        <div className="priority-breakdown">
          <div className="priority-item">
            <span className="label">Critical</span>
            <span className="count">
              {rfi.rfiItems.filter(i => i.priority === 'Critical').length}
            </span>
          </div>
          <div className="priority-item">
            <span className="label">High</span>
            <span className="count">
              {rfi.rfiItems.filter(i => i.priority === 'High').length}
            </span>
          </div>
          <div className="priority-item">
            <span className="label">Medium</span>
            <span className="count">
              {rfi.rfiItems.filter(i => i.priority === 'Medium').length}
            </span>
          </div>
          <div className="priority-item">
            <span className="label">Low</span>
            <span className="count">
              {rfi.rfiItems.filter(i => i.priority === 'Low').length}
            </span>
          </div>
        </div>
      </div>

      <div className="rfi-actions">
        <button className="btn btn-secondary" onClick={onBack}>
          Back to Dashboard
        </button>
        <button className="btn btn-primary" onClick={onExportPDF}>
          Export as PDF
        </button>
      </div>
    </div>
  );
}

export default RFIViewer;
